import { fetchCurationAPI } from '@/apis/repositories/controllers/curationRepository';
import {
  fetchNovelDetailAPI,
  fetchNovelListAPI,
  fetchSearchNovelListAPI,
} from '@/apis/repositories/controllers/novelRepository';
import { NovelPayload } from '@/apis/repositories/types/novel';
/* 웹소설 베스트 작품 조회 */
export function fetchNovelBestList() {
  return fetchCurationAPI({ visiblePosition: 'NOVEL', type: 'BEST_SELLER' });
}

/* 웹소설 전체 작품 조회 */
export function fetchNovelList(params: NovelPayload) {
  return fetchNovelListAPI(params);
}
/* 웹소설 전체 작품 조회 */
export function fetchSearchNovelList(params: NovelPayload) {
  return fetchSearchNovelListAPI(params);
}
/* 웹소설 상세정보 조회 */
export function fetchNovelDetail(novelSeq: number) {
  return fetchNovelDetailAPI(novelSeq);
}
